import React from 'react'
import { Link } from 'react-router-dom'

const Form = () => {
    return (
        <>
            <section
                id="faqs-form"
                className="faqs-form-main-block contact-form-main-block"
            >
                <div className="container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-5 col-md-5">
                            <div className="faqs-form-dtls">
                                <h4 className="sub-heading">Contact Us</h4>
                                <h1 className="heading">Do You Have Any Question?</h1>
                                <p>
                                    For your car we will do everything advice, repairs and maintenance.
                                    We are the some preferred choice by many car owners because
                                </p>
                                <ul className="footer-social-icons">
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-facebook" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-twitter" />
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="#" title="" />
                                        <i className="flaticon-linkedin" />
                                    </li>
                                    <li>
                                        <Link to="#" title="">
                                            <i className="flaticon-pinterest" />
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-7 col-md-7">
                            <form action="">
                                <div className="row">
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="name"
                                                placeholder="Your Name"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="email"
                                                className="form-control"
                                                id="email"
                                                placeholder="Your Email"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="number"
                                                className="form-control"
                                                id="phone"
                                                placeholder="Phone Number"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-md-6">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="subject"
                                                placeholder="Subject"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="service"
                                                placeholder="Service"
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <textarea
                                                className="form-control"
                                                id="message"
                                                placeholder="Your Message"
                                                rows={7}
                                                defaultValue={""}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12">
                                        <button className="btn btn-primary faqs-buttons">
                                            Submit Now
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Form
